<template>
  <div>
    <Modal class="editBlock servelistModal" v-model="modal" title="编辑客服" width="35" footer-hide>
      <div class="bodyhigh">
        <div class="bodytwice">
          <div class="content">
            <Row>
              <Col span="12">
                <label>帐号</label>
                <Input class="editInput account" v-model="ma.account" type="text" disabled></Input>
              </Col>
              <Col offset="1" span="11">
                <label>組織</label>
                <Select class="editInput department" v-model="ma.depaid">
                  <Option
                    v-for="(item,idx) in depalist"
                    :value="item.depaid"
                    :key="idx"
                  >{{item.depaname}}</Option>
                </Select>
              </Col>
            </Row>
            <div class="bodytwice-bottom">
              <Row>
                <Col span="12">
                  <label>昵称</label>
                  <Input class="editInput" v-model="ma.nickname" type="text"></Input>
                </Col>
                <Col offset="1" span="11">
                  <label>手机</label>
                  <Input class="editInput cellphone" v-model="ma.phnum" type="text"></Input>
                  <p v-if="cellphoneStatus" class="cellphoneHint">請輸入數字</p>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div class="btn" @click="editConfirm">储存</div>
          <div class="btn" @click="reset">重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "ModalStructureMa",
  props: {
    serveStatus: {
      type: Boolean,
      required: true
    },
    maobj: {
      type: Object,
      required: true
    },
    depalist: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      ma: {
        account: '',
        nickname: '',
        phnum: '',
        depaid: '',
        image: 'http://imgsoure.local.host/updateimg/upload/141920220191209153034.jpge',
      },
      cellphoneStatus: false,
      tempoMa: ''
    }
  },
  watch: {
    maobj () {
      this.tempoMa = JSON.parse(JSON.stringify(this.maobj))
      this.ma.account = this.tempoMa.account
      this.ma.depaid = this.tempoMa.depaid
      this.ma.nickname = this.tempoMa.nickname
      this.ma.phnum = this.tempoMa.phnum
    }
  },
  computed: {
    ...mapGetters(['username']),
    modal: {
      get () {
        return this.serveStatus
      },
      set (val) {
        this.$emit("update:maobj", {})
        this.$emit("update:serveStatus", val)
      }
    }
  },
  methods: {
    //编辑确定
    editConfirm () {
      if (this.cellphoneJadge(this.ma.phnum)) return;
      if (!this.ma.phnum || !this.ma.nickname || !this.ma.depaid) {
        this.$Message.error("栏位皆为必填");
        return;
      }
      let obj = {
        id: Number(this.maobj.maid),
        updatetype: "1",
        ...this.ma
      }
      this.$axios.updpersonal(obj)
        .then(res => {
          this.$emit("getMalistData")
          this.$emit("filterDepalsit")
        })
        .catch(err => console.error(err))
      this.reset()
      this.modal = false
    },

    //reset
    reset () {
      this.ma.phnum = ''
      this.ma.nickname = ''
      this.ma.depaid = ''
    },
    cellphoneJadge (val) {
      if (isNaN(Number(val))) {
        this.cellphoneStatus = true
      } else {
        this.cellphoneStatus = false
      }
      return this.cellphoneStatus
    }
  }
}
</script>
<style lang="less">
.servelistModal {
  .editInput {
    &.cellphone {
      width: 76%;
      margin-left: 15px;
    }
    &.account {
      margin-left: 7px;
    }
    &.email {
      width: 90%;
    }
    &.department {
      margin-left: 15px;
      width: 76%;
    }
  }
  .passwordAgain {
    p {
      color: var(--main-red);
      margin-top: -10px;
      margin-left: 70px;
    }
  }
  .cellphoneHint {
    margin-left: 50px;
    margin-top: -8px;
    color: var(--main-red);
  }
}
</style>